module.exports = __webpack_public_path__ + "2d3bec7c9696a166de3d7955b37cbede.MP3";